const $ = window.jQuery;
import 'slick-carousel';

import _ from 'lodash';

$(() => {
    const $sliders = $('.bleeding-slider__slides');

    if (!$sliders.length) {
        return;
    }

    _.each($sliders, slider => {
        const $slider = $(slider);
        const type = $slider.parent().attr('data-type');

        let args = {
            infinite: false,
            appendArrows: $slider
                .parent()
                .find('.bleeding-slider__arrows')
                .first(),
            prevArrow: `<button class="bleeding-slider__button slick-prev"><i class="icon-arrow-left"></i><span class="bleeding-slider__button-text">Previous Slide</span></button>`,
            nextArrow: `<button class="bleeding-slider__button slick-next"><i class="icon-arrow-right"></i><span class="bleeding-slider__button-text">Next Slide</span></button>`,
        };

        if (type === 'variable-width') {
            args['slidesToShow'] = 1;
            args['variableWidth'] = true;
            args['dots'] = true;
            args['appendDots'] = $slider
                .nextAll('.bleeding-slider__dots')
                .first();
        } else if (type === 'cards') {
            args['slidesToShow'] = 4;
            args['responsive'] = [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                    },
                },
                {
                    breakpoint: 860,
                    settings: {
                        slidesToShow: 2,
                    },
                },
            ];
        } else if( type === 'exhibition-cards' ) {
            args['slidesToShow'] = 3;
            args['responsive'] = [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 860,
                    settings: {
                        slidesToShow: 2,
                    },
                },
            ];
        }

        $slider.slick(args);

        let lastSlide = false;

        $slider.on('afterChange', (event, slick) => {
            const { currentSlide, slideCount } = slick;
            const { slidesToShow } = slick.options;

            if (lastSlide) {
                $slider.trigger('edge');
            }

            if (
                !lastSlide &&
                slideCount - 1 === currentSlide + slidesToShow - 1
            ) {
                lastSlide = true;
            } else if (
                lastSlide &&
                slideCount - 1 > currentSlide + slidesToShow - 1
            ) {
                lastSlide = false;
            }
        });

        $slider.on('edge', function(event, slick, direction) {
            $slider.slick('slickGoTo', 0);
        });

        if (type === 'cards' || type === 'exhibition-cards') {
            const $slides = $slider.find('.slick-slide');

            $(window).on(
                'resize orientationchange',
                _.throttle(() => setSlideHeights($slider, $slides), 200),
            );

            setTimeout( () => {
                setSlideHeights($slider, $slides);
            }, 750 );

            function setSlideHeights(slider, slides) {
                _.each(slides, slide => {
                    $(slide).css({ height: '' });
                });

                let tallest = 0;

                _.each($(slider).find('.card'), slide => {
                    const height = $(slide).outerHeight(true);
                    if (height > tallest) {
                        tallest = height;
                    }
                });

                _.each(slides, slide => {
                    $(slide).css({ height: tallest });
                });
            }
        }
    });
});
